import {
  makeStyles,
  Theme,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import Footer from '~/components/Footer';
import Header from '~/components/Header';
import {MobileWeb} from '~/components/Mobile/Breakpoints';
import {LangCode, setLang} from '~/features/Login/slice';

const useStyles = makeStyles((theme) => ({
  layout: {
    maxWidth: 980,
    width: '100%',
    margin: '0 auto',
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      minWidth: 360,
    },
  },

  fnqDiv: {
    fontSize: theme.typography.pxToRem(15),
    marginTop: 40,
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      padding: '0 15px',
    },
  },

  fnqHeader: {
    backgroundColor: '#eee',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 70,
    marginBottom: 30,
  },

  fnqContent: {},

  contentF: {
    display: 'flex',
    borderBottom: '0.5px solid #eee',
    height: 45,
    alignItems: 'center',
    '&:first-child': {
      borderTop: '0.5px solid #eee',
    },
  },
  contentN: {
    marginRight: 8,
  },

  fnqBottom: {
    padding: '10px 18px',
    borderBottom: '0.5px solid #eee',
    [theme.breakpoints.down(MobileWeb.mobile)]: {
      padding: '10px 0px',
    },
  },
}));

const Fnq = () => {
  const classes = useStyles();
  const {t} = useTranslation();

  const theme = useTheme() as Theme;
  const mobile = useMediaQuery(theme.breakpoints.down(MobileWeb.mobile));

  // 번역

  const [headerLang, setHeaderLang] = useState<LangCode>();

  useEffect(() => {
    if (headerLang !== undefined) {
      setLang(headerLang);
    }
  }, [headerLang]);

  return (
    <div>
      <Header
        langProp={(headerLang: LangCode) => {
          setHeaderLang(headerLang);
        }}
      />
      {/* main text start */}
      <div className={classes.layout}>
        <div className={classes.fnqDiv}>
          <div className={classes.fnqHeader}>
            <div>
              <Typography variant="h4">{t('FAQ')}</Typography>
            </div>
          </div>
          <div className={classes.fnqContent}>
            <div className={classes.contentF}>
              <div className={classes.contentN}>
                <Typography variant={mobile ? 'caption' : 'body1'}>
                  {t('1.')}
                </Typography>
              </div>
              <Typography variant={mobile ? 'caption' : 'body1'}>
                {t('무료 글공고_')}
              </Typography>
            </div>
            <div
              className={classes.contentF}
              style={{display: mobile ? 'revert' : 'flex'}}>
              <div style={{display: 'flex'}}>
                <div className={classes.contentN}>
                  <Typography variant={mobile ? 'caption' : 'body1'}>
                    {t('2.')}
                  </Typography>
                </div>
                <div>
                  <Typography variant={mobile ? 'caption' : 'body1'}>
                    {t('유료 공고 게재_')}
                  </Typography>
                </div>
              </div>

              <div>
                <Typography
                  variant={mobile ? 'caption' : 'body1'}
                  color="error">
                  {t('1공고_')}
                </Typography>
              </div>
            </div>
            <div className={classes.contentF}>
              <div className={classes.contentN}>
                <Typography variant={mobile ? 'caption' : 'body1'}>
                  {t('3.')}
                </Typography>
              </div>
              <Typography variant={mobile ? 'caption' : 'body1'}>
                {t('최저시급 미만_')}
              </Typography>
            </div>
            <div className={classes.contentF}>
              <div className={classes.contentN}>
                <Typography variant={mobile ? 'caption' : 'body1'}>
                  {t('4.')}
                </Typography>
              </div>
              <Typography variant={mobile ? 'caption' : 'body1'}>
                {t('허위, 비방, 명예훼손_')}
              </Typography>
            </div>
          </div>
          <div className={classes.fnqBottom}>
            <div>
              <Typography variant={mobile ? 'caption' : 'body1'}>
                {t('사용 사업주 및_')}
              </Typography>
            </div>
            <div>
              <Typography variant={mobile ? 'caption' : 'body1'}>
                {t('감사합니다.')}
              </Typography>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Fnq;
